import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.VUE_APP_STUDIO_FIREBASE_CONFIG_API_KEY,
  authDomain: process.env.VUE_APP_STUDIO_FIREBASE_CONFIG_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_STUDIO_FIREBASE_CONFIG_DATABASE_URL,
  projectId: process.env.VUE_APP_STUDIO_FIREBASE_CONFIG_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STUDIO_FIREBASE_CONFIG_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_STUDIO_FIREBASE_CONFIG_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_STUDIO_FIREBASE_CONFIG_APP_ID,
  measurementId: process.env.VUE_APP_STUDIO_FIREBASE_CONFIG_MEASUREMENT_ID,
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.auth().useDeviceLanguage();

window.firebase = firebase;

const { Timestamp } = firebase.firestore;

export default firebase;

export { Timestamp };
